import { render, staticRenderFns } from "./manaulMenu.vue?vue&type=template&id=66f352c5&scoped=true&"
import script from "./manaulMenu.vue?vue&type=script&lang=js&"
export * from "./manaulMenu.vue?vue&type=script&lang=js&"
import style0 from "./manaulMenu.vue?vue&type=style&index=0&id=66f352c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f352c5",
  null
  
)

export default component.exports